import { useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/Button';
import Logo from 'src/logos/Logo';
import css from './Login.module.scss';

export default function Verify() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    navigate('/');
  };

  return (
    <div className={css.page}>
      <Logo width="260px" />
      <div className={css.box}>
        <div className={css.component}>
          <div className={css.inputs}>
            <h1>Successfully Connected POS to Livecart!</h1>
            <p style={{ marginBottom: '16px', marginTop: '16px' }}>
              Your POS has been connected to Livecart. Your locations and items are currently being
              synchronized.
              <br />
              Click 'Continue' to return to Livecart Merchant.
            </p>
				
            <div className={css.buttons}>
              <Button
                action={() => handleSubmit()}
                label="Continue"
                color="white"
                // href='us'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
